import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import useOrderContext from '@modules/order/hooks/use-order-context'
import useViewContext from '@modules/order/hooks/use-view-context'
import { PRODUCT_OPERATIONS_LOADERS } from '@modules/order/stores/view/List/ListDataStore'
import classNames from 'classnames'
import get from 'lodash/get'
import { useObserver } from 'mobx-react-lite'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { getNumberFromLocale } from '@utils/get-number-form-locale'
import FieldSkeleton from '@api/order/components/CellLoaders/FieldSkeleton'
import QtyNumberInput from '@modules/order/components/CellTemplates/components/QtyNumberInput/QtyNumberInput'
import { EnhancedListUIStore } from '@modules/showroom/EnhancedOrder/stores/EnhancedListView/EnhancedListUIStore'
import { CentricTypography as Typography } from '@core/component/CentricTypography'
import { makeStyles } from '@material-ui/core'
import EnhancedCell from './EnhancedCell'

const useStyles = makeStyles(theme => ({
  inputBox: {
    width: 100,
    height: 20,
    marginTop: 0
  },
  message: {
    paddingTop: 8
  }
}))
const EnhancedAverageWeekSales: FC<CellItem> = ({ rowData, column, cellData }) =>
  useObserver(function useHook() {
    const {
      uiStore: { isOrderEditable }
    } = useOrderContext()
    const classes = useStyles()
    const viewContextVal = useViewContext()
    const { t } = useTranslation()
    if (!rowData) {
      return <FieldSkeleton />
    }
    const uiStore = viewContextVal.uiStore as EnhancedListUIStore<any>
    const index = rowData?.id
      ? uiStore.dataStore.itemIndexObjectStore.getIndexByKey(rowData.id)
      : null
    const value = get(rowData, column?.enhancedField) ?? 0
    const disabled = index
      ? uiStore.dataStore.itemIndexObjectStore.isObjectsDataLoading(
          index,
          index + 1,
          PRODUCT_OPERATIONS_LOADERS.UPDATING_CLIENT_ORDER_DRAFT_QUANTITY
        )
      : false
    const salesPeriodNumberOfWeeks = get(rowData, 'retailSalesPeriod-numberOfWeeks')
    const invalidValue = !salesPeriodNumberOfWeeks

    return (
      <EnhancedCell className={classNames('flex justify-start column align-center')}>
        <QtyNumberInput
          id={rowData.id}
          isDecimal={true}
          onChange={e => {
            uiStore.updateProductQuantity(
              rowData?.id,
              // newProductQty = (newAWS * salesPeriodWeeks) / (salesQty/oldProductqty) // sellthrough
              Math.round(
                (getNumberFromLocale(e.target.value) * (salesPeriodNumberOfWeeks || 0)) /
                  (get(rowData, 'salesQuantity') /
                    get(rowData, 'clientOrderProductQuantity') || 1) || 1
              ),
              {}
            )
          }}
          value={Number(value || 0).toFixed(2)}
          disabled={disabled || invalidValue || !isOrderEditable}
          className={classes.inputBox}
        />
        {invalidValue && (
          <div className={classes.message}>
            <Typography variant='overlineDarkGrey'>
              {t('order.salesPeriodEmptyMessage', 'No Sales Periods')}
            </Typography>
          </div>
        )}
      </EnhancedCell>
    )
  })

export default EnhancedAverageWeekSales
